// extracted by mini-css-extract-plugin
export default {"form":"Bgy_SMAQ","inputLine":"IL2R8yt7","submitButtons":"tfHPfaSQ"};